import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TemplateSearchComponent } from './template-search-om/template-search.component';
import { QualiopiPictoComponent } from './qualiopi-picto-om/qualiopi-picto.component';


@NgModule({
  providers: [DatePipe],
  imports: [
    CommonModule,
    FormsModule,
  ],
  declarations: [
    TemplateSearchComponent,
    QualiopiPictoComponent,
  ],
  exports: [
    TemplateSearchComponent,
    QualiopiPictoComponent,
  ]
})

export class TemplateSearchModule { }
